var alertNotifications = {
	alert: {
		limitAbove: "Límite superior cruzado",
		limitBelow: "Límite inferior cruzado"
	},
	closeBtn: "Cerrar",
	openHistory: "Abrir historial de alertas"
};
var es = {
	alertNotifications: alertNotifications
};

export { alertNotifications, es as default };
